export default __webpack_public_path__ + "static/media/3.cef89691.png";